var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100vh","display":"flex","justify-content":"center","align-items":"center"}},[_c('el-empty',{attrs:{"description":"404"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }